export function renameTitle(str: string) {
    if (str.includes(ChildrenCategories["children_3_10"])) {
        return "Дети от 3 до 10 лет"
    }
    if (str.includes(ChildrenCategories["children_11_15"])) {
        return "Подростки от 11 до 15 лет"
    }
    if (str.includes(ChildrenCategories["children_16_18"])) {
        return "Подростки от 16 до 18 лет"
    }
    return str
}

export enum ChildrenCategories {
    "children_3_10" = "С детьми от 3 до 10 лет",
    "children_11_15" = "С подростками от 11 до 15 лет",
    "children_16_18" = "С подростками от 16 до 18 лет",
}
